import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { AssessmentsService } from '../../services/assessments.service';

@Component({
  selector: 'app-nix',
  standalone: true,
  imports: [RouterModule],
  template: '',
})
export class AssessmentBaseComponent {
  protected assessmentsService: AssessmentsService = inject(AssessmentsService);
  protected router: Router = inject(Router);
  protected route: ActivatedRoute = inject(ActivatedRoute);
  private snackBar: MatSnackBar = inject(MatSnackBar);

  constructor(public dialog: MatDialog) { }

  onDelete(assessmentId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Wirklich löschen?',
        description: 'Wollen Sie die Testung wirklich löschen?',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'YES') {
        this.assessmentsService.deleteAssessment(assessmentId!).then(res => {
          this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
          this.snackBar.open('Die Testung wurde erfolgreich gelöscht.', '', {
            duration: 3000,
          });
        });
      }
    });
  }
}
